
import { initializeApp } from "firebase/app"
import { getFirestore } from 'firebase/firestore/lite'

const firebaseConfig = {
    databaseURL: "https://tgg-web-api-v2/firestore/data.firebaseio.com",
    projectId: "tgg-web-api-v2",
}

// const firebaseConfig = {
//     databaseURL: "https://tgg-web-api.firebaseio.com",
//    projectId: "tgg-web-api",
//  }

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

//console.log('db in utilities:',db)



export {db }
